import { MapboxHelper } from './mapbox-map-helper';

import * as _ from 'lodash';
import { FeatureCollection } from '@turf/turf';

// a class for rendering layers that are connected to the same source
export abstract class MapLayerRenderer {
    private _renderedLayerNames: { [key: string]: string[] } = {};
    private _allRenderLayerNames = [];
    public get renderedLayerNames(): string[] {
        return this._allRenderLayerNames;
    }

    protected _sourceLayer: string;
    protected _sourceId: string;

    constructor(
        protected _mapboxHelper: MapboxHelper,
    ) {
        // generate the sourceId
        this._sourceId = Math.random().toString(36).substr(2, 30);
    }

    // sourcelayer is used for vector sources only
    public setSourceLayer(sourceLayerName: string) {
        this._sourceLayer = sourceLayerName;
    }

    public updateSourceLayer(sourceLayerName: string) {
        this._sourceId = Math.random().toString(36).substr(2, 30);
        this._sourceLayer = sourceLayerName;
    }

    public get sourceId() {
        return this._sourceId;
    }

    public get sourceLayer() {
        return this._sourceLayer;
    }

    public reset() {
        this._allRenderLayerNames = [];
        this._renderedLayerNames = {};
    }

    public getAllLayerNames(layerName: string) {
        return this._renderedLayerNames[layerName];
    }

    // for updating a source that is geojson
    public updateData(map: mapboxgl.Map, fc: GeoJSON.FeatureCollection) {
        const modifiedFc = this.modifyFeatureCollection(fc);

        const updatedData = this._mapboxHelper.updateSourceData(map, modifiedFc, this._sourceId);
        if (!updatedData) {
            this._mapboxHelper.createSource(map, modifiedFc, this._sourceId);
        }
    }

    public render(map: mapboxgl.Map) {
        const sourceExists = this._mapboxHelper.sourceExists(map, this._sourceId);
        if (sourceExists) {
            this.renderLayers(map);
            this._allRenderLayerNames = _.flatten(_.values(this._renderedLayerNames));
        }
    }

    protected addLayerNames(layers: { [key: string]: string[] }) {
        Object.keys(layers).forEach(key => {
            this._addLayerNames(key, layers[key]);
        });
    }

    protected _addLayerNames(key: string, layerNames: string[]) {
        if (!this._renderedLayerNames[key]) {
            this._renderedLayerNames[key] = [];
        }

        if (!layerNames || layerNames.length === 0) {
            return; // finns inga nya lagernamn att lägga till, onödigt att göra operationen nedan
        }

        this._renderedLayerNames[key] = _.uniq(this._renderedLayerNames[key].concat(layerNames));
    }

    // function that should render the layers connected to the source and
    // adding the names to the _renderedLayerNames
    protected abstract renderLayers(map: mapboxgl.Map): void;

    protected abstract modifyFeatureCollection(fc: GeoJSON.FeatureCollection): GeoJSON.FeatureCollection;
}
